import { create } from 'zustand'
import fetcher from "../fetcher";

export const usePricingsStore = create((set, get) => ({
    pricingData: [],
    setPricingData: (value) => set(() => ({pricingData: value})),

    isLoading: false,
    setIsLoading: (value) => set(() => ({isLoading: value})),

    search: "",
    setSearch: (value) => set(() => ({search: value})),

    fetchPricings: async (make, params) => {
        set({isLoading: true})
        const response = await fetcher.getPricingsForMake(make, params)
        const pricingData = response?.data
        set({isLoading: false, pricingData: pricingData})
    }
}))